import { z } from 'zod';
import { coveredInseeCodesSchema, MAX_COVERED_MUNICIPALITIES, municipalitySchema, } from '../inquiry/municipality.js';
import { teamLoadSchema } from './team-load.js';
/**
 * La **couverture** d'une équipe — les communes de son « secteur d'intervention », dit le
 * prototype validé (`TeamCoverage`, M22, Q14). Les marchés ont disparu (#661) : une équipe n'en a
 * plus, ses communes suffisent.
 */
/**
 * Une commune couverte, et **la charge de l'équipe dans cette commune** — les deux
 * compteurs de `load`, restreints aux demandes dont l'adresse y est.
 *
 * C'est ce que l'onglet « Secteur » du prototype met sur chaque carte de commune (« À réaliser »,
 * « Réalisés » et la barre d'avancement), compté en base (D24) plutôt que recompté dans le
 * navigateur sur une page de demandes. ⚠️ Une demande de l'équipe **hors** de ses communes ne se
 * compte dans aucune carte : elle reste dans `load`, qui est la charge entière.
 */
export const coveredMunicipalitySchema = municipalitySchema.extend({
    load: teamLoadSchema,
});
/** La couverture telle que la composition d'équipe la rend : ses communes **triées par nom** (D24). */
export const teamCoverageSchema = z.object({
    municipalities: z.array(coveredMunicipalitySchema),
});
export { coveredInseeCodesSchema, MAX_COVERED_MUNICIPALITIES };
/**
 * Ce que l'écran envoie pour **remplacer** la couverture d'une équipe : la liste entière des codes
 * INSEE retenus. `PUT`, idempotent — rejouée, l'écriture rend le même état.
 *
 * ⚠️ **La liste vide est une valeur**, pas un oubli : c'est retirer toutes les communes.
 */
export const updateTeamCoverageSchema = z.strictObject({
    inseeCodes: coveredInseeCodesSchema,
});
//# sourceMappingURL=team-coverage.js.map